import { useAppSelector } from 'src/hooks';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { minHeight } from '@mui/system';
import BarChart from './bar-chart';
import './index.scss';
import { MetricsModule } from '../../types/simulation-summary.model';
import '../../simulation-summary.scss';
import { abbreviateNumber } from '../../utils/utils';
import { chartTypeMap } from '../../utils/constants';
import SummaryTable from '../summary/summary-table/summary-table-component';

export default function MetricsBarChartComponent({
  chartData,
  barWidthValue,
  summaryMetrics
}: {
  // chartData: BarChartDetails;
  chartData: any;
  barWidthValue: number;
  summaryMetrics: MetricsModule[];
}) {
  const { isUnitSelected, isPlotSelected } = useAppSelector(
    (state) => state.summary
  );

  const axisKeysForMetrics = [];
  summaryMetrics
    .slice()
    .sort((a, b) => a.order - b.order)
    .forEach((metric) => {
      axisKeysForMetrics.push({
        key: metric.module,
        alias: metric.alias,
        color:
          chartData.module_impact.find((data) => data.module === metric.module)
            .change_abs < 0
            ? '#B80302'
            : '#0FB052'
      });
    });

  let metricsChartData = {};

  // variable for storing summary table data (splitted abs and perc data)
  let metricsTableData = {};

  chartData.module_impact.forEach((element) => {
    /* eslint-disable prefer-object-spread */
    metricsChartData = Object.assign({}, metricsChartData, {
      [element.module]: element.change_abs
    });

    // preparing data for metrics table/text component
    metricsTableData = Object.assign({}, metricsTableData, {
      [element.module]: [
        element.change_abs,
        // (element.change_abs / chartData.current) * 100
        element.change_perc
      ]
    });
  });
  return (
    <div
      key={`chart_${chartData.metric}`}
      style={{
        borderTop: '1px dashed #C4C4C4',
        marginTop: '21px',
        minHeight: '188px',
        minWidth: '140px'
      }}
    >
      <div className=' flex-div' style={{ margin: '5px 5px 5px 5px' }}>
        <div
          style={{ fontSize: '12px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
        >
          {abbreviateNumber(chartData.currency_label, chartData.change_abs, 1)}
        </div>
        <div
          className={`flex-div ${
            chartData.change_perc > 0 ? 'positive-div' : 'negative-div'
          }`}
          style={{ fontSize: '12px', fontWeight: 'bold' }}
        >
          {chartData.change_perc > 0 ? (
            <ArrowDropUpIcon />
          ) : (
            <ArrowDropDownIcon />
          )}
          {chartData.change_perc}%
        </div>
      </div>
      <div className='legend-div'>
        {!isPlotSelected && (
          <BarChart
            barWidthValue={barWidthValue}
            barData={metricsChartData}
            height={250}
            axisKeys={axisKeysForMetrics}
            type={chartTypeMap.metricsDifferenceChart}
          />
        )}
        {isPlotSelected && (
          <SummaryTable
            barWidthValue={barWidthValue}
            barData={metricsTableData}
            height={250}
            axisKeys={axisKeysForMetrics}
            type={chartTypeMap.metricsDifferenceChart}
          />
        )}
      </div>
    </div>
  );
}
